/* js/components/PlyrAudioPlayer.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	src_url_equal
} from "svelte/internal";

import Plyr from 'plyr';
import { onMount, onDestroy } from 'svelte';

function create_fragment(ctx) {
	let div;
	let audio;
	let source;
	let source_src_value;

	return {
		c() {
			div = element("div");
			audio = element("audio");
			source = element("source");
			if (!src_url_equal(source.src, source_src_value = /*src*/ ctx[0])) attr(source, "src", source_src_value);
			attr(source, "type", "audio/mp3");
			attr(audio, "id", "player");
			audio.controls = true;
			attr(div, "class", "audio-container svelte-1htojbu");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, audio);
			append(audio, source);
			/*audio_binding*/ ctx[2](audio);
		},
		p(ctx, [dirty]) {
			if (dirty & /*src*/ 1 && !src_url_equal(source.src, source_src_value = /*src*/ ctx[0])) {
				attr(source, "src", source_src_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			/*audio_binding*/ ctx[2](null);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { src } = $$props;
	let audioDomElement;
	let plyr;

	onMount(() => {
		const options = { settings: [] };
		plyr = new Plyr(audioDomElement, options);
	});

	onDestroy(() => {
		plyr.destroy();
	});

	function audio_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			audioDomElement = $$value;
			$$invalidate(1, audioDomElement);
		});
	}

	$$self.$$set = $$props => {
		if ('src' in $$props) $$invalidate(0, src = $$props.src);
	};

	return [src, audioDomElement, audio_binding];
}

class PlyrAudioPlayer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { src: 0 });
	}
}

export default PlyrAudioPlayer;